enum InvestorGroupedInvestmentEndpoints {
  getOne = "/grouped-investment",
  getMany = "/grouped-investments",
}

export default InvestorGroupedInvestmentEndpoints;
